<template>
  <!-- popup (s) -->
  <div class="popWrap">
    <div class="popup">
      <div class="popContain">
        <div class="popCont photoView full">
          <div class="popHead">
            <h1 class="titH1">확대보기</h1>
          </div>
          <div class="popBody photoView full">
            <div class="popInner">
              <!-- 본문 (s) -->
              <div class="zoomImg">
                <img
                  :key="index"
                  :src="`data:image/${photo.fileTpMCntn === 'jpg' ? 'jpeg' : photo.fileTpMCntn};base64,${photo.file}`"
                  style="padding-top: 10px;"
                />
              </div>
              <!-- 본문 (e) -->
            </div>
          </div>

          <button type="button" class="btnIco_close" @click="$emit('close')"><span>팝업 닫기</span></button>
        </div>
      </div>
    </div>
  </div>
  <!-- popup (e) -->
</template>

<script>
export default {
  name: 'ReviewSinglePhotoPop',
  props: ['photo'],
};
</script>
